import React, { useState, Suspense, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ButtonContainer } from '../../TrainingRoutes/Quiz/QuizPageStyles.styles';
import NameDetails from './Name.component';
import LoginDetails from './LoginDetails.component';
import DeleteAccount from './DeleteAccount.component';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { httpEditUser } from '../../Hooks/admin/admin.put.hooks';
import { BottomButtonOuter } from './UserSettingsStyles.styles';
const PrimaryButton = React.lazy(
  () => import('../../Components/Buttons/PrimaryButton/PrimaryButton.component')
);
const SecondaryButton = React.lazy(
  () =>
    import('../../Components/Buttons/SecondaryButton/SecondaryButton.component')
);
const UserSettingsInner = ({ user }) => {
  const [userData, setUserData] = useState();
  const [status, setStatus] = useState('');
  useEffect(() => {
    setUserData(user);
  }, [user]);

  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ id, userData }) => httpEditUser(id, userData),
    onSuccess: async (data) => {
      let message = await data.json();
      queryClient.invalidateQueries(['user', user?._id]);
      setStatus(message.msg || 'Your profile has been edited');
    },
    onError: async (error) => {
      let err = await error.json();
      console.error('Error editing profile:', error);
      setStatus(err.msg || 'Failed to edit profile');
    },
  });

  const handleEdit = async (e) => {
    e.preventDefault();
    setStatus('Editing your profile...');
    mutation.mutate({ id: user._id, userData });
  };

  return (
    <form>
      <NameDetails user={userData} setUser={setUserData} />
      <LoginDetails user={userData} setUser={setUserData} />
      <DeleteAccount user={userData} />
      <BottomButtonOuter>
        {/* For the bottom 2 buttons */}
        <p style={{ textAlign: 'center', fontWeight: 'bold' }}>{status}</p>
        <ButtonContainer>
          <Suspense fallback={<div>Loading button...</div>}>
            <SecondaryButton
              functionName={(e) => {
                e.preventDefault();
                navigate(`/user`);
              }}
              span="Home"
            />
            <PrimaryButton functionName={handleEdit} span="Update Profile" />
          </Suspense>
        </ButtonContainer>
      </BottomButtonOuter>
    </form>
  );
};
UserSettingsInner.propTypes = {
  user: PropTypes.object,
};

export default UserSettingsInner;
